import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import { NotAuthorized, NotFound } from '../components/Error';
import { MainFooter } from '../components/Footers';
import { Loading } from '../components/Loading';
import { HomeNavbar } from '../components/Navbars';
import { MainSidebar } from '../components/Sidebar';
import * as actions from '../redux/actions';
import accessRight from '../utils/functions/accessRight';
import {
  ConclusionPurchaseOrder,
  CreateMaterialPurchaseOrder,
  CreatePurchaseOrder,
  DetailPurchaseOrder,
  EditMaterialPurchaseOrder,
  EditPurchaseOrder,
  MaterialPurchaseOrder,
  PurchaseOrder,
} from '../views/PMS';
// Sales and Purchase Management
export const PMS = () => {
  const module = 'PMS';
  const prefix = '/pms';
  const name = 'ฝ่ายจัดซื้อ';
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const me = useSelector((state) => state.me);
  const availableModule = useSelector((state) => state.availableModule);
  const information = useSelector((state) => state.information);

  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const handleOnMobileNavOpen = () => {
    setMobileNavOpen(true);
  };

  const handleOnMobileNavClose = () => {
    setMobileNavOpen(false);
  };

  useEffect(() => {
    console.log('Layout: PMS');
    dispatch(actions.meGet());
    dispatch(actions.informationAll());
    dispatch(actions.availableModuleAll());
    return () => {};
  }, []);

  if (!me?.userData) {
    return <Loading />;
  }

  if (accessRight(me, module, 0, availableModule)) {
    return (
      <div className="min-h-screen">
        <Helmet>
          <meta charSet="utf-8" />
          <title>ฝ่ายจัดซื้อ - {information?.name || 'E-Manufac'}</title>
        </Helmet>
        <MainSidebar
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
          me={me}
        />
        <HomeNavbar onMobileNavOpen={handleOnMobileNavOpen} />
        <div className="lg:ml-64  min-h-screen  pt-16 px-8 ">
          <div className="py-4">
            <Switch>
              <Redirect
                exact
                from={`${prefix}`}
                to={`${prefix}/material-order`}
              />
              <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
              <Route exact path={`${prefix}/material-order`}>
                <MaterialPurchaseOrder
                  title="คำสั่งซื้อวัตถุดิบ"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/material-order/create`}>
                <CreateMaterialPurchaseOrder
                  title="เพิ่มคำสั่งซื้อวัตถุดิบ"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/material-order/edit/:id`}>
                <EditMaterialPurchaseOrder
                  title="แก้ไขคำสั่งซื้อวัตถุดิบ"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/material-list`}>
                <ConclusionPurchaseOrder
                  title="สรุปคำสั่งซื้อวัตถุดิบ"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/purchase-order`}>
                <PurchaseOrder title="รายการสั่งซื้อวัตถุดิบ" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/purchase-order/create`}>
                <CreatePurchaseOrder
                  title="เพิ่มรายการสั่งซื้อวัตถุดิบ"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/purchase-order/:id`}>
                <DetailPurchaseOrder
                  title="รายละเอียดการสั่งซื้อวัตถุดิบ"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/purchase-order/edit/:id`}>
                <EditPurchaseOrder
                  title="แก้ไขข้อมูลสั่งซื้อวัตถุดิบ"
                  subtitle={name}
                />
              </Route>
              <Route path="*">
                <NotFound />
              </Route>
            </Switch>
          </div>
        </div>
        <div className="lg:ml-64">
          <MainFooter />
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="min-h-screen">
        <MainSidebar
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
          me={me}
        />
        <HomeNavbar onMobileNavOpen={handleOnMobileNavOpen} />
        <NotAuthorized />
        <div className="lg:ml-64">
          <MainFooter />
        </div>
      </div>
    </div>
  );
};

export default PMS;
